// extracted by mini-css-extract-plugin
export default {"container":"modal-description_container__1SJir"};